import { render, staticRenderFns } from "./FormDatasource.vue?vue&type=template&id=36d09ef3&"
import script from "./FormDatasource.vue?vue&type=script&lang=js&"
export * from "./FormDatasource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports